import styled from "styled-components";
import { FaBars } from "react-icons/fa";
import { FaSearch } from "react-icons/fa";
import { Link } from "react-router-dom";

export const MenuIcon = styled(FaBars)`
  font-size: 1.5rem;
  color: #fff;
  display: flex;
  cursor: pointer;
`;

export const SearchIcon = styled(FaSearch)`
  margin: 0 1rem 0 0;
  color: #fff;
  cursor: pointer;
  font-size: 1.5rem;
`;

export const HeaderContainer = styled.section`
  position: sticky;
  top: 0;
  z-index: 4;
  width: 100%;
`;

export const Navbar = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: 0;
  padding: 0.625rem;
  color: rgb(177, 177, 177);
  box-shadow: 0 0 20px -2px black;
  height: 7vh;
  background-color: #111;
`;

export const NavSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NavSearch = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 400px) {
    display: none;
  }
`;

export const SearchBar = styled.input`
  background-color: transparent;
  border: none;
  padding: 5px 0;
  display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
  &:focus {
    outline: none;
    border-bottom: 1px solid #fff;
  }
  &::placeholder {
    color: #fff;
  }
`;

export const NavLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  & h2 {
    font-family: "Montserrat", sans-serif;
    font-weight: 400;
  }

  @media screen and (max-width: 768px) {
    flex: 7;
  }
`;

export const LogoImg = styled.img`
  object-fit: contain;
  height: 100%;
`;
